import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { createMavenirConfigRecord, createOranConfigRecord } from '@api/schemaConfig';

import { ICreateSchemaDTO } from '@interfaces/cmModule/dto/schemaConfigDTO';
import { IOnClose } from '@interfaces/common/handlers';

import {
	CREATE_SCHEMA,
	MAVENIR_SCHEMA_CONFIG,
	ORAN_VALUES_FOR_CREATE_SCHEMA,
	VALUES_FOR_CREATE_SCHEMA,
} from '@constants/queryKeys';

interface IUseCreateMavenirConfig extends IOnClose {
	isOranVendor: boolean;
}

interface ICreateMavenirConfigReturnType {
	createMavenirConfig: UseMutateFunction<any, any, ICreateSchemaDTO, any>;
	isLoadingCreateMavenirConfig: boolean;
}

export const useCreateMavenirConfig = ({
	onClose,
	isOranVendor,
}: IUseCreateMavenirConfig): ICreateMavenirConfigReturnType => {
	const queryClient = useQueryClient();
	const queryFn = isOranVendor ? createOranConfigRecord : createMavenirConfigRecord;

	const {
		mutate: createMavenirConfig,
		isLoading: isLoadingCreateMavenirConfig,
	} = useMutation<ICreateSchemaDTO>({
		mutationKey: [CREATE_SCHEMA],
		mutationFn: queryFn,
		onSuccess: () => {
			onClose();

			if (isOranVendor) {
				return [
					queryClient.invalidateQueries([ORAN_VALUES_FOR_CREATE_SCHEMA]),
					queryClient.invalidateQueries([MAVENIR_SCHEMA_CONFIG]),
				];
			}
			return [
				queryClient.invalidateQueries([VALUES_FOR_CREATE_SCHEMA]),
				queryClient.invalidateQueries([MAVENIR_SCHEMA_CONFIG]),
			];
		},
	});

	return {
		createMavenirConfig,
		isLoadingCreateMavenirConfig,
	};
};
